import type { PublicRuntimeConfig } from 'nuxt/schema';
import { fetchAlgolia } from '../../../ui/composables/searchApi';
import { useSearchStore } from '../store/search';

export async function useUpdateAirportByCode(config: PublicRuntimeConfig, airportCode: string, store: boolean = true) {
    if (!config.ALGOLIA_ENABLED) {
        console.error(`No Algolia API key provided`);
        return;
    }
    if (!config.ALGOLIA_INDEX || !airportCode) {
        console.error('Wrong arguments provided for useUpdateAirportByCode');
        return;
    }
    const searchStore = useSearchStore();
    return await fetchAlgolia(config, airportCode).then((res) => {
        let data = res?.hits?.[0];

        res?.hits?.forEach((item: any) => {
            if (item.hierarchy.airport_code.toLowerCase() === airportCode.toLowerCase()) {
                data = item;
            }
        });

        const itemParsed = {
            airport_code: data?.hierarchy.airport_code,
            fullname: data?.display?.full,
            location: {
                latitude: data?._geoloc?.lat,
                longitude: data?._geoloc?.lng,
            },
            type: data?.type,
        };

        if (store) {
            searchStore.update({ destination: itemParsed });
        }
        return itemParsed;
    });
}
